<h1 class="text-white text-lg font-semibold mb-4">Revisión de liquidación</h1>

<div *ngIf="header" class="bg-gray-800 p-4 rounded mb-4 text-white">
    <div class="flex flex-wrap gap-6">
        <div><span class="font-semibold">Semana:</span> {{ header.week }}</div>
        <div><span class="font-semibold">Año:</span> {{ header.year }}</div>
        <div><span class="font-semibold">Mes:</span> {{ (header.month || 'N/D') | uppercase }}</div>
        <div><span class="font-semibold">Estado:</span> {{ getTranslatedStatus(header.status) | uppercase }}</div>
    </div>
</div>

<div class="mb-4 flex justify-between items-center" *ngIf="header">
    <div></div>
    <mat-form-field class="ml-4 border-0">
        <input matInput (input)="applyFilter($event)" placeholder="Buscar cliente...">
    </mat-form-field>
</div>

<div *ngIf="dataSource.data.length === 0" class="text-center py-8 text-gray-500">
    <p>No hay liquidaciones de clientes.</p>
</div>

<div class="mat-elevation-z2" *ngIf="dataSource.data.length > 0">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">

        <ng-container matColumnDef="partnerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
            <td mat-cell *matCellDef="let row"> {{ row.partnerName }} </td>
        </ng-container>

        <ng-container matColumnDef="totalToInvoice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Total a facturar </th>
            <td mat-cell *matCellDef="let row"> Q {{ row.totalToInvoice | number:'1.2-2' }} </td>
        </ng-container>

        <ng-container matColumnDef="totalToDeposit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Total a depositar </th>
            <td mat-cell *matCellDef="let row"> Q {{ row.totalToDeposit | number:'1.2-2' }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
            <td mat-cell *matCellDef="let row"> {{ getTranslatedStatus(row.status) }} </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
            <td mat-cell *matCellDef="let row"> {{ row.createdAt | date:'dd-MM-yyyy, HH:mm' }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let row">
                <button mat-icon-button color="primary" aria-label="Ver detalle"
                        [routerLink]="['/liquidations', header?.liquidationId, 'reviews', row.partnerId]">
                    <mat-icon>visibility</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" [pageSize]="10" showFirstLastButtons aria-label="Paginador de liquidaciones"></mat-paginator>
</div>
